<div *ngIf="companyId">
  <i *ngIf="courtship" #icon class="courtship-icon mr-1" [ngClass]="getCompanyCourtshipIcon()"
    [ngStyle]="{'color': getCompanyCourtshipColor(), 'cursor': readOnly ? 'cursor' : 'pointer' }"
    (click)="handleCourtshipChange()"
     (mouseenter)="showTooltip(tooltipTemplate, icon)"
     (mouseleave)="hideTooltip()">
    <ng-template #tooltipTemplate>
      <div class="crm-tooltip" (mouseenter)="showTooltip(tooltipTemplate, icon)" (mouseleave)="hideTooltip()">
        <div class="tooltip-inner">
          <div class="courtship-label">{{ courtshipLabels[courtship] }}:</div>
          <div class="courtship-affirm ml-1" (click)="affirmCourtship()">
            Affirm
            <i class="fa ml-1" [ngClass]="courtshipAffirmed ? 'fa-check-circle' : 'fa-check-circle-o'"></i>
          </div>
        </div>
      </div>
    </ng-template>
  </i>

  <img *ngIf="seniorAttention !== null && seniorAttention !== undefined"
       class="senior-icon" [src]="'assets/icons/' + getSeniorAttentionIcon()"
     [ngStyle]="{'filter': getSeniorAttentionColor(), 'cursor': readOnly ? 'cursor' : 'pointer'}"
     (click)="handleSeniorChange()" alt="senior-attention" />
</div>
